var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9212 5.03034C14.9212 5.03764 14.9212 5.04428 14.9165 5.05159L13.4105 11.9492C13.3641 12.1921 13.2345 12.4112 13.0439 12.5688C12.8534 12.7264 12.6138 12.8125 12.3665 12.8125H2.63338C2.38623 12.8124 2.14684 12.7261 1.95642 12.5686C1.76601 12.411 1.63648 12.192 1.59014 11.9492L0.0840456 5.05159C0.0840456 5.04428 0.0807253 5.03764 0.0793971 5.03034C0.038177 4.80197 0.0728569 4.56638 0.178138 4.35958C0.283419 4.15277 0.453511 3.98612 0.662425 3.88509C0.871339 3.78406 1.10758 3.7542 1.33506 3.80008C1.56255 3.84596 1.76875 3.96506 1.92217 4.13917L4.15807 6.54905L6.53541 1.21729C6.53552 1.21508 6.53552 1.21286 6.53541 1.21065C6.62042 1.02627 6.75648 0.870108 6.92748 0.760649C7.09848 0.65119 7.29726 0.593018 7.5003 0.593018C7.70333 0.593018 7.90211 0.65119 8.07311 0.760649C8.24411 0.870108 8.38017 1.02627 8.46518 1.21065C8.46507 1.21286 8.46507 1.21508 8.46518 1.21729L10.8425 6.54905L13.0784 4.13917C13.2322 3.96635 13.4381 3.84842 13.665 3.80329C13.8918 3.75816 14.1272 3.78829 14.3354 3.88911C14.5436 3.98993 14.7131 4.15593 14.8184 4.3619C14.9236 4.56787 14.9588 4.80256 14.9185 5.03034H14.9212Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.b9e9d538372d1a86a45a64f8b2457d90.svg";
export { ForwardRef as ReactComponent };